import { render, staticRenderFns } from "./Botfooter.vue?vue&type=template&id=7cec585c&scoped=true&"
import script from "./Botfooter.vue?vue&type=script&lang=js&"
export * from "./Botfooter.vue?vue&type=script&lang=js&"
import style0 from "./Botfooter.vue?vue&type=style&index=0&id=7cec585c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cec585c",
  null
  
)

export default component.exports